module.exports = __webpack_public_path__ + "img/icon33.06368850.png";